var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon",class:_vm.glyph + '-icon',style:(_vm.style),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('svg',{staticStyle:{"width":"100%","height":"100%"}},[_c('use',_vm._b({},'use',{ 'xlink:href': '#' + _vm.glyph },false))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04a57f01","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Icon.vue
// module id = null
// module chunks = 